import { ArrowLeft, Ghost } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4">
      <div className="text-center space-y-8">
        <Ghost className="w-32 h-32 mx-auto text-base-content animate-bounce" />
        
        <div className="space-y-4">
          <h1 className="text-8xl font-bold">404</h1>
          <p className="text-2xl">{t('notfound.title')}</p>
          <p className="text-lg opacity-60">{t('notfound.text')}</p>
        </div>

        <button 
          onClick={() => navigate('/')}
          className="btn btn-lg gap-2 btn-ghost"
        >
          <ArrowLeft className="w-6 h-6" />
          {t('notfound.back')}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
